import { GET_BLASTING_REPORT_DETAIL, GET_BLASTING_REPORT_LIST } from 'fixtures/actions';
import { BLASTING_REPORTS } from 'fixtures/api';
import { getAllList } from 'services/cmsService';

const getAllBlastingData = (params, cb) => {
  return async dispatch => {
    let data = []
    let newData = await getAllList(`${BLASTING_REPORTS}?${params}`)
    if (newData && !('errors' in newData)) {
      data = newData.reduce((acc, item) => {
        item.details.detailPit.forEach((pit) => {
          acc.push({
            id: item.id,
            idPitInfo: pit.id,
            pit: pit.pitInfo.pit,
            pitName: pit.pitInfo.pitName,
            drillDate: item.drillDate,
            blastingDate: item.blastingDate,
            contractor: item.contractor,
            sectionFrom: pit.pitInfo.sectionFrom,
            sectionTo: pit.pitInfo.sectionTo,
            rl: pit.pitInfo.negativeRl ? "- " + pit.pitInfo.rl : "+ " + pit.pitInfo.rl,
            actual: pit.pitInfo.negativeActual ? "- " + pit.pitInfo.actual : "+ " + pit.pitInfo.actual,
            reportedBy: item.createdBy,
            status: item.status,
            remark: pit.pitInfo.remark
          })
        })
        return acc
      }, [])
      .sort((a, b) => {
          return a.contractor.name.localeCompare(b.contractor.name) || 
                a.pitName.localeCompare(b.pitName) || b.blastingDate.localeCompare(a.blastingDate) 
      })
    }
    cb && cb()
    
    dispatch({
      type: GET_BLASTING_REPORT_LIST,
      payload: data
    })
  }
}

const getBlastingReportDetail = (id) => {
  return async dispatch => {
    let data = {}
    let newData = await getAllList(`${BLASTING_REPORTS}/${id}`)
    if (newData) {
      data = JSON.parse(JSON.stringify(newData), (key, value) => {
        // check if the current value is a string containing numbers
        if (key !== "pit" && typeof value === "string" && /^-?\d+(\.\d+)?$/.test(value)) {
          // parse the string into a number
          const num = parseFloat(value)
          // return the number with commas and period as separators
          return num.toLocaleString('en-US')
        }
        // return the original value for other types
        return value
      })
    }

    dispatch({
      type: GET_BLASTING_REPORT_DETAIL,
      payload: data
    })
  }
}

export { getBlastingReportDetail, getAllBlastingData }